import { FC, ReactElement } from "react";
import { useUserGeneralProfile } from "../../hooks/useUserGeneralProfile";

interface UserGeneralProfileProps {
  userId: string;
  entityId: string;
  children: (props: ReturnType<typeof useUserGeneralProfile>) => ReactElement;
}

export const UserGeneralProfile: FC<UserGeneralProfileProps> = ({
  userId,
  entityId,
  children,
}) => {
  const userGeneralProfile = useUserGeneralProfile({ userId, entityId });
  return children(userGeneralProfile);
};
